<template>
  <div class="drip-card invoice-updates-section mb-3">
    <div
      class="section-header d-flex justify-content-between"
      @click="collapse = !collapse"
    >
      <h3>
        {{ $t('invoices.single.updates.title') }}
      </h3>
      <div class="d-md-none align-self-center mr-3">
        <b-icon-chevron-up class="icon-2x" v-if="collapse" />
        <b-icon-chevron-down class="icon-2x" v-else />
      </div>
    </div>
    <ul
      class="section-body section p-3 d-md-block"
      v-if="hasTaskUpdates"
      v-show="collapse"
    >
      <li
        v-for="taskFlow in invoice.task_flows"
        :key="taskFlow.id"
        v-if="taskFlow.metadata && taskFlow.status === 'completed'"
        class="pb-2"
      >
        <div class="subtitle">
          {{ $t(`invoices.single.updates.${taskFlow.metadata.message_key}`) }}
          {{ taskFlow.metadata.email }}
        </div>
        <div class="title font-weight-normal">
          {{ taskFlow.updated_at | formatDate('D MMMM, YYYY') }}
        </div>
      </li>
    </ul>
    <div
      class="section-body section p-3 title d-flex justify-content-center"
      v-else
    >
      {{ $t('invoices.single.noUpdates') }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      collapse: false
    }
  },
  props: ['invoice'],
  mounted() {
    this.$mpTrack('Invoice details - Updates component rendered')
  },
  computed: {
    hasTaskUpdates() {
      let taskFlows = this.invoice.task_flows
      for (let i = 0; i < taskFlows.length; i++) {
        if (taskFlows[i].status === 'completed' && taskFlows[i].metadata) {
          return true
        }
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/variables';
.invoice-updates-section {
  font-family: $lato;
  h3 {
    font-weight: bold;
    color: $dc-input-color;
    font-size: 1rem;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    padding: 1rem 1rem;
    line-height: 1.5;
    margin-bottom: 0;
    .collapse-icon {
      float: right;
      svg {
        cursor: pointer;
      }
    }
  }
  .section-header {
    border-bottom: 1px solid $dc-form-border-color;
  }
  .section-body {
    overflow: scroll;
    max-height: 72vh;
    font-family: $montserrat;
    padding-left: 0;
    list-style: none;
    li {
      padding-left: 10px;
    }
  }
}
</style>
